import ICharacter from '#/types/characters';
import IStory from '#/types/stories';
import { StoriesActionType, TStoriesActions } from '../actions/stories';

interface IState {
  stories: IStory[];
  characters: ICharacter[];
  selectedCharacter: ICharacter['id'] | undefined;
  page: number;
  totalPages: number;
  loading: boolean;
}

const initialState: IState = {
  stories: [],
  characters: [],
  selectedCharacter: undefined,
  page: 1,
  totalPages: 0,
  loading: false,
};

const storiesReducer = (
  state = initialState,
  action: TStoriesActions
): IState => {
  switch (action.type) {
    case StoriesActionType.STORIES_SET_STORIES:
      return { ...state, stories: action.payload };

    case StoriesActionType.STORIES_SET_CHARACTERS:
      return { ...state, characters: action.payload };

    case StoriesActionType.STORIES_SET_SELECTED_CHARACTER:
      return { ...state, selectedCharacter: action.payload };

    case StoriesActionType.STORIES_SET_PAGE:
      return { ...state, page: action.payload };

    case StoriesActionType.STORIES_SET_TOTAL_PAGES:
      return { ...state, totalPages: action.payload };

    case StoriesActionType.STORIES_START_LOADING:
      return { ...state, loading: true };

    case StoriesActionType.STORIES_STOP_LOADING:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default storiesReducer;
